import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DocumentTemplateService } from '@fi-app/document-template/document-template.service';
import { Transition } from '@uirouter/core';
import { Injector } from '@angular/core';
import { coerceNumberProperty } from '@angular/cdk/coercion';

export const FiDocumentTemplateStatesResolveTemplate = [
    FiStateService,
    DocumentTemplateService,
    Injector,
    Transition,
    FiDocumentTemplateStatesResolveTemplateResolveFunc,
];

export function FiDocumentTemplateStatesResolveTemplateResolveFunc(
    fiStateService: FiStateService,
    documentTemplateService: DocumentTemplateService,
    injector: Injector,
    tr: Transition,
) {
    const templateId = coerceNumberProperty(fiStateService.getParams(tr).Id);
    return documentTemplateService.GetTemplate(templateId);
}
